const CandidateUtility = {
  noInfo(candidate) {
    return (
      this.isNullOrWhitespace(candidate.topics) &&
      this.isNullOrWhitespace(candidate.slogan) &&
      this.isNullOrWhitespace(candidate.education) &&
      this.isNullOrWhitespace(candidate.experience) &&
      this.isNullOrWhitespace(candidate.extracurricular) &&
      this.isNullOrWhitespace(candidate.hobbies) &&
      this.isNullOrWhitespace(candidate.campaignBudgetComment) &&
      this.isNullOrWhitespace(candidate.campaignBudget) &&
      (this.isNullOrWhitespace(candidate.termsInOffice) ||
        candidate.termsInOffice.length === 0) &&
      (this.isNullOrWhitespace(candidate.vestedInterests) ||
        candidate.vestedInterests.length === 0)
      // this.isNullOrWhitespace(candidate.books) &&
      // this.isNullOrWhitespace(candidate.civilStatus) &&
      // this.isNullOrWhitespace(candidate.denomination) &&
      // this.isNullOrWhitespace(candidate.movies) &&
      // this.isNullOrWhitespace(candidate.music) &&
    );
  },
  isNullOrWhitespace(s) {
    return s == null || s === "" || s === "<p><br></p>";
  }
};

export { CandidateUtility };
